/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './doctor-charges.reducer';

export const DoctorCharges = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const doctorChargesList = useAppSelector(state => state.doctorCharges.entities);
  const loading = useAppSelector(state => state.doctorCharges.loading);
  const totalItems = useAppSelector(state => state.doctorCharges.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="doctor-charges-heading" data-cy="DoctorChargesHeading">
        <Translate contentKey="tinyMedicRestApp.doctorCharges.home.title">Doctor Charges</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.doctorCharges.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/doctor-charges/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.doctorCharges.home.createLabel">Create new Doctor Charges</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.doctorCharges.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {doctorChargesList && doctorChargesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('consultationCharge')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.consultationCharge">Consultation Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consultationCharge')} />
                </th>
                <th className="hand" onClick={sort('followupCharge')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.followupCharge">Followup Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupCharge')} />
                </th>
                <th className="hand" onClick={sort('followupDays')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.followupDays">Followup Days</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupDays')} />
                </th>
                <th className="hand" onClick={sort('followupVisits')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.followupVisits">Followup Visits</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('followupVisits')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('chargeType')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.chargeType">Charge Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargeType')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('addedByID')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.addedByID">Added By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByID')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th className="hand" onClick={sort('emergencyHike')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.emergencyHike">Emergency Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergencyHike')} />
                </th>
                <th className="hand" onClick={sort('hishRiskHike')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.hishRiskHike">Hish Risk Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hishRiskHike')} />
                </th>
                <th className="hand" onClick={sort('emergencyHikeType')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.emergencyHikeType">Emergency Hike Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergencyHikeType')} />
                </th>
                <th className="hand" onClick={sort('hishRiskHikeType')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.hishRiskHikeType">Hish Risk Hike Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hishRiskHikeType')} />
                </th>
                <th className="hand" onClick={sort('multiplierApplied')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.multiplierApplied">Multiplier Applied</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplierApplied')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.doctor">Doctor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.hospital">Hospital</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorCharges.specialty">Specialty</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {doctorChargesList.map((doctorCharges, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/doctor-charges/${doctorCharges.id}`} color="link" size="sm">
                      {doctorCharges.id}
                    </Button>
                  </td>
                  <td>{doctorCharges.consultationCharge}</td>
                  <td>{doctorCharges.followupCharge}</td>
                  <td>{doctorCharges.followupDays}</td>
                  <td>{doctorCharges.followupVisits}</td>
                  <td>{doctorCharges.active ? 'true' : 'false'}</td>
                  <td>{doctorCharges.microSec}</td>
                  <td>{doctorCharges.lastupdated}</td>
                  <td>{doctorCharges.timestampentry}</td>
                  <td>{doctorCharges.cursor}</td>
                  <td>{doctorCharges.chargeType}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${doctorCharges.addedByType}`} />
                  </td>
                  <td>{doctorCharges.addedByID}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${doctorCharges.modifiedByType}`} />
                  </td>
                  <td>{doctorCharges.modifiedByID}</td>
                  <td>{doctorCharges.emergencyHike}</td>
                  <td>{doctorCharges.hishRiskHike}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.HikeType.${doctorCharges.emergencyHikeType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.HikeType.${doctorCharges.hishRiskHikeType}`} />
                  </td>
                  <td>{doctorCharges.multiplierApplied ? 'true' : 'false'}</td>
                  <td>{doctorCharges.startDate}</td>
                  <td>{doctorCharges.endDate}</td>
                  <td>{doctorCharges.suspended ? 'true' : 'false'}</td>
                  <td>{doctorCharges.draft ? 'true' : 'false'}</td>
                  <td>{doctorCharges.doctor ? <Link to={`/doctor/${doctorCharges.doctor.id}`}>{doctorCharges.doctor.id}</Link> : ''}</td>
                  <td>
                    {doctorCharges.hospital ? <Link to={`/hospital/${doctorCharges.hospital.id}`}>{doctorCharges.hospital.id}</Link> : ''}
                  </td>
                  <td>
                    {doctorCharges.scheme ? <Link to={`/payment-scheme/${doctorCharges.scheme.id}`}>{doctorCharges.scheme.id}</Link> : ''}
                  </td>
                  <td>
                    {doctorCharges.specialty ? (
                      <Link to={`/especialty/${doctorCharges.specialty.id}`}>{doctorCharges.specialty.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/doctor-charges/${doctorCharges.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/doctor-charges/${doctorCharges.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/doctor-charges/${doctorCharges.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.doctorCharges.home.notFound">No Doctor Charges found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={doctorChargesList && doctorChargesList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DoctorCharges;
